<template>
  <div class="page-menu-drawer mobile-nav">
    <div class="page-menu-title">
      <a @click="closeMenu"><span class="af af-close page-menu-close"></span></a>
      <div class="bold">Menu</div>
    </div>
    <div class="page-menu-drawer-items">
      <template v-for="item in items">
        <template v-if="!enableNewNavigation">
          <Expandable
            v-if="item.items && item.items.length"
            :key="item.id"
            :open="expanded[item.id]"
            @toggle="(open) => toggle(item, open)"
            :class="item.name"
          >
            <template v-slot:header="props">
              <span>{{ item.name }}</span
              ><span v-if="props.open" class="af af-minus"></span><span v-else class="af af-plus"></span>
            </template>
            <template v-slot:content>
              <div v-for="menuItem in item.items" :key="'s-' + menuItem.name" class="secondary-menu-link">
                <a
                  @click.prevent="loadUrl(menuItem.url)"
                  :class="[{ 'page-menu-drawer-accent': routeItem && routeItem.id === menuItem.id }, menuItem.name]"
                >
                  {{ menuItem.name }}
                </a>
              </div>
            </template>
          </Expandable>
          <a
            v-else
            :key="item.id"
            class="page-menu-drawer-item"
            :href="item.url"
            :class="[{ 'page-menu-drawer-accent': routeItem && routeItem.id === item.id }, item.name]"
          >
            {{ item.name }}
          </a>
        </template>
      </template>
      <div class="page-menu-banner-items">
        <template v-for="bannerLink in bannerNavigationLinks" :key="bannerLink.id">
          <a class="page-menu-drawer-item" :href="bannerLink.url">
            {{bannerLink.name}}
          </a>
        </template>
      </div>
    </div>
    <div class="page-menu-drawer-items">
      <a class="page-menu-drawer-item" :href="accountUrl"><i class="menu-icon af af-account"></i><span>My account</span></a>
      <a class="page-menu-drawer-item" :href="favoritesUrl"><i class="menu-icon af af-heart"></i><span>My favorites</span></a>
      <a class="page-menu-drawer-item" :href="aboutUrl"><i class="menu-icon af af-about-small"></i><span>About</span></a>

      <Expandable>
        <template v-slot:header="props">
          <span v-if="country === 'CA'" class="page-menu-country"
            ><img class="menu-icon country-button-flag" :src="caFlag" /><span>Country: CA</span></span
          >
          <span v-else class="page-menu-country"><img class="menu-icon country-button-flag" :src="usFlag" /><span>Country: US</span></span>

          <span v-if="props.open" class="af af-minus"></span>
          <span v-else class="af af-plus"></span>
        </template>
        <template v-slot:content>
          <a class="page-menu-drawer-item" @click="onChangeCountry('US')">
            <img class="country-button-flag menu-icon" :src="usFlag" /><span>United States</span>
          </a>
          <a class="page-menu-drawer-item" @click="onChangeCountry('CA')">
            <img class="country-button-flag menu-icon" :src="caFlag" /><span>Canada</span>
          </a>
        </template>
      </Expandable>
    </div>
  </div>
</template>
<script>
import { Expandable } from '@/pixel/index';
import caFlag from '@/assets/flags/ai-Can.png';
import usFlag from '@/assets/flags/ai-US.png';
import Tracking from '@/components/commons/Tracking.js';

export default {
  components: {
    Expandable,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
    bannerNavigationLinks: {
      type: Array,
      default: () => [],
    },
    routeItem: {
      type: Object,
      default: null,
    },
    aboutUrl: {
      type: String,
      required: true,
    },
    accountUrl: {
      type: String,
      required: true,
    },
    favoritesUrl: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
    helpCenterUrl: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      caFlag,
      usFlag,
      expanded: {},
      enableNewNavigation: false,
    };
  },

  watch: {
    routeItem: {
      immediate: true,
      handler(routeItem) {
        if (routeItem) {
          if (routeItem.parentMenuItem) {
            this.expanded[routeItem.parentMenuItem] = true;
          }
          if (routeItem.parentId) {
            this.expanded[routeItem.parentId] = true;
          }
        }
      },
    },
  },

  methods: {
    loadUrl(url) {
      Tracking.track('NAV_ITEM_CLICKED', { newNavEnabled: this.enableNewNavigation, target: url });
      window.location = url;
    },

    onChangeCountry(country) {
      this.$emit('changeCountry', country);
    },

    closeMenu() {
      this.$emit('close');
    },

    toggle(item, open) {
      this.expanded[item.id] = open;
      if (this.enableNewNavigation && window.hj && open) {
        window.hj('trigger', 'image_nav');
      }
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.page-menu-drawer {
  .page-menu-title {
    display: flex;
    align-items: center;
    padding: var(--space-3) 20px var(--space-3) 20px;
  }

  .page-menu-drawer-items {
    border-top: 1px solid var(--grey-ultra-light);
  }

  .page-menu-banner-items {
    border-top: 1px solid var(--grey-ultra-light);
    border-bottom: 1px solid var(--grey-ultra-light);
  }

  .page-menu-close {
    margin-right: 20px;
  }

  .page-menu-drawer-icons {
    display: flex;
    justify-content: center;
  }

  .page-menu-drawer-icon {
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .af {
      font-size: 2em;
    }
  }

  .page-menu-drawer-country {
    display: flex;
    justify-content: center;
    margin-bottom: 70px;
  }

  .page-menu-drawer-item,
  .page-menu-drawer-subitem {
    display: flex;
    align-items: center;
    padding: var(--space-4) var(--space-6) var(--space-4) var(--space-6);
    span.af-plus {
      height: var(--space-10);
      width: var(--space-10);
      border-radius: 20px;
      text-align: center;
      position: relative;
      right: -11px;
      margin-left: auto;
    }
  }

  .subitems {
    width: 50%;
  }

  .expandable-content {
    display: flex;
    padding: 0;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 5px;
  }

  .secondary-menu-link {
    width: 100%;
    padding: var(--space-4) var(--space-10);
  }

  .final {
    position: relative;
    left: -5px;
    .cover {
      width: calc(100% + 10px);
    }
    .preserve-ratio-container {
      min-height: 137px;
      min-width: 265px;
    }
    a {
      position: absolute;
      display: block;
      text-align: center;
      font-weight: bold;
      bottom: var(--space-4);
      z-index: 2;
      width: calc(100% - 32px);
      padding: var(--space-1) var(--space-3);
      left: 0%;
      margin: 0 22px;
      letter-spacing: 1.4px;
      font-size: 12px;
      box-sizing: border-box;
      border-radius: var(--button-border-radius);
      background-color: white;
      text-transform: uppercase;
    }
  }
  .menu-icon {
    margin-right: var(--space-4);
  }

  .country-button-flag {
    width: var(--space-4);
    height: var(--space-4);
  }

  .page-menu-country {
    display: flex;
    align-items: center;
  }

  .page-menu-drawer-accent {
    color: var(--coral);
  }
}
</style>
